import { HttpErrorResponse } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { FileTypeT3 } from 'src/app/core/enums/user/file-type';
import { revisionHistoryAccessTypeEnum } from 'src/app/core/models/ckEditor/revisionData';
import { SelfAssessmentDocumentModel } from 'src/app/core/models/self-assessment/self-assessment-document-model';
import { overallAssessmentDropdownList } from 'src/app/core/models/self-assessmentT3/overallDropdownList';
import { UserProfile } from 'src/app/core/models/user';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { SelfAssessmentTemplate3Service } from 'src/app/core/services/self-assessment-template3/self-assessment-template3.service';
import { ModalDialogComponent } from '../../distributed-ui-components/modal-dialog/modal-dialog.component';
import { ckEditorBroadcastMessage } from 'src/app/core/models/signalR/ckEditorBroadcastMessage';
import {
  SelfAssessmentCkDataSaveT3Dto,
  overallAssessmentDto,
  overallAssessmentVersionDto,
} from 'src/app/core/models/self-assessmentT3/overall-aseesment';
import { SignalRService } from 'src/app/core/services/signalR/signal-r.service';
import { SelfAssessmentNew } from 'src/app/core/models/self-assessmentT2/self-assessmentT2';
import { MasterHelper } from 'src/app/core/utilities';
import { SelfAssessmentCkDataSaveModel } from 'src/app/core/models/self-assessmentT2/update-self-assessmentT2-model';
import { CkEditorRevisionComponent } from '../../shared/ck-editor-revision/ck-editor-revision.component';
import { debug } from 'console';
import {
  overAllApprovalSaveData,
  overAllAssessmentSaveData,
  overAllReviewSaveData,
} from 'src/app/core/models/self-assessmentT3/saveDataModel';
import { GlobalService } from 'src/app/core/services/global/global.service';
import {
  VersionFilterViewT3Model,
  VersionHistoryT3DataDto,
} from 'src/app/core/models/self-assessmentT3/version-filter-viewT3-model';
import { SelfAssessmentDialogComponent } from '../../self-assessment/self-assessment-dialog/self-assessment-dialog.component';
import { TimePickerComponent } from '../../shared/time-picker/time-picker.component';
import { Observable } from 'rxjs';
import { userDropdownDto } from 'src/app/core/models/self-assessmentT3/SelfAssessmentInterpretation';
import { MatChipInputEvent } from '@angular/material/chips';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { FormControl } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { rightsManagementSAT3Dto } from 'src/app/core/models/self-assessmentT3/SelfAssessmentT3Filter';
import { cloneDeep } from 'lodash'
@Component({
  selector: 'app-self-assessment-template3-overall-assessment',
  templateUrl: './self-assessment-template3-overall-assessment.component.html',
  styleUrls: ['./self-assessment-template3-overall-assessment.component.scss'],
})
export class SelfAssessmentTemplate3OverallAssessmentComponent
  implements OnInit {
  isLoader: boolean = false;
  @Input() summaryDetailsId!: string;
  previousOverallAssessmentData: overallAssessmentDto =
    new overallAssessmentDto(
      0,
      '',
      '',
      '',
      new Date(''),
      new Date(''),
      '',
      '',
      // true,
      // true,
      // true,
      null,
      null,
      null,
      '',
      '',
      '',
      new Date(''),
      '',
      '',
      '',
      '',
      '',
      '',
      0,
      '',
      new Date(''),
      '',
      '',
      '',
      '',
      new Date(''),
      '',
      false
    );
  overallAssessmentData: overallAssessmentDto = new overallAssessmentDto(
    0,
    '',
    '',
    '',
    new Date(''),
    new Date(''),
    '',
    '',
    // true,
    // true,
    // true,
    null,
    null,
    null,
    '',
    '',
    '',
    new Date(''),
    '',
    '',
    '',
    '',
    '',
    '',
    0,
    '',
    new Date(''),
    '',
    '',
    '',
    '',
    new Date(''),
    '',
    false
  );
  overallAssessmentVersionData: overallAssessmentVersionDto =
    new overallAssessmentVersionDto(
      0,
      0,
      '',
      '',
      '',
      new Date(),
      new Date(),
      '',
      '',
      true,
      true,
      true,
      '',
      '',
      '',
      new Date(),
      '',
      '',
      '',
      '',
      '',
      '',
      0,
      '',
      new Date(),
      '',
      '',
      '',
      '',
      new Date(),
      '',
      false,
      0,
      ''
    );
  @ViewChild('topicInput')
  topicInput!: ElementRef<HTMLInputElement>;
  @ViewChild('topicInput2')
  topicInput2!: ElementRef<HTMLInputElement>;
  accessType: revisionHistoryAccessTypeEnum | undefined;
  user: UserProfile = new UserProfile();
  isAssessmentLoader: boolean = false;
  isReviewLoader: boolean = false;
  assessorTeam: string[] = [];
  searchedTopic: string[] = [];
  impactBussinessArea: string[] = [];
  @ViewChild('topicAutocomplete')
  topicAutocomplete!: MatAutocomplete;
  @ViewChild('topicAutocomplete2')
  topicAutocomplete2!: MatAutocomplete;
  addOnBlur = true;
  isActionLoader: boolean = false;
  isAssessmentLastEdited: boolean = false;
  isReviewLastEdited: boolean = false;
  isActionLastEdited: boolean = false;
  isToastShow = false;
  toastModel: ToastViewModel = new ToastViewModel();
  overallAssessmentDropdownList: overallAssessmentDropdownList =
    new overallAssessmentDropdownList();
  selfAssessmentDocument: SelfAssessmentDocumentModel[] = [];
  @ViewChild('uploadEviAssessmentT3') uploadEviAssessmentT3: any;
  @ViewChild('reviewEvidanceT3') reviewEvidanceT3: any;
  @ViewChild('ActionEvidanceT3') ActionEvidanceT3: any;
  @ViewChildren(CkEditorRevisionComponent) ckEditorComponent:
    | QueryList<CkEditorRevisionComponent>
    | undefined;
  isButtonDisabled: boolean = false;
  isButtonDisabledReview: boolean = false;
  isButtonDisabledAction: boolean = false;
  @Input() isBulkUpdate: boolean = false;
  @Input() selectedItems: number[] = [];
  filterType!: string;
  reviewerFilterList: userDropdownDto[] = [];
  searchTopicCntrl: FormControl = new FormControl();
  searchTopicCntrl2: FormControl = new FormControl();
  @ViewChild('reviewerAutoComplete')
  reviewerAutoComplete!: MatAutocomplete;
  @ViewChild('reviewerInput')
  reviewerInput!: ElementRef<HTMLInputElement>;
  searchReviewerCntrl: FormControl = new FormControl();
  searchedReviewers: userDropdownDto[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  isUserRestricted: boolean = true;
  isReviewUserRestricted: boolean = true;
  allReviewerList: userDropdownDto[] = [];
  allAssessorList: userDropdownDto[] = [];
  allActionOwnerList: userDropdownDto[] = [];
  constructor(
    private _selfAssessmentT3Service: SelfAssessmentTemplate3Service,
    private route: ActivatedRoute,
    private _sessionService: SessionService,
    public dialog: MatDialog,
    private _signalRService: SignalRService,
    private _globalService: GlobalService,
    private ref: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA)
    public versionHistoryData: VersionHistoryT3DataDto
  ) {
    this.accessType = revisionHistoryAccessTypeEnum.All;
    if (this.filterType === undefined) {
      this.filterType = this.route.snapshot.params['filter'];
    }
  }
  ngOnInit() {
    if (this.versionHistoryData && this.versionHistoryData.isVersonHistory) {
      this.summaryDetailsId = this.versionHistoryData.summarydetailsId;
      this.fetchSelfAssessmentVersionHistoryDetails();
    } else {
      if (!this.isBulkUpdate) {
        if (!this.summaryDetailsId) {
          this.route.params.subscribe((params: any) => {
            this.summaryDetailsId = params['id'];
          });
        }
        this.getAllSelfAssessmentT3Service();
        this.getAssessmentDocuments();
      }
    }
    this.getUserDetails();
    this.getOverallAssessmentAllDropDowns();
  }
  getAllSelfAssessmentT3Service() {

    this._selfAssessmentT3Service
      .getT3OverAllAssessment(this.summaryDetailsId)
      .subscribe((res: overallAssessmentDto) => {
        if (res) {
          this.assessorTeam = res.assessorTeam ? res.assessorTeam.split(',') : this.assessorTeam;
          this.impactBussinessArea = res.impactBusinessArea ? res.impactBusinessArea.split(',') : this.impactBussinessArea;
          this.overallAssessmentData = new overallAssessmentDto(
            res.id,
            res.assessorName,
            res.assessmentCategory,
            res.assessmentStatus,
            res.assessmentDate,
            res.nextAssessmentDueDate,
            res.assessorTeam,

            res.impactBusinessArea,
            res.lbgImpact,
            res.rfbImpact,
            res.lbcmImpact,
            res.assessmentFindings,
            res.reviewerComments,
            res.actionDetails,
            res.actionClosed,
            res.assessmentUploadEvidance,
            res.complianceStatus,
            res.muteAssessmentFindingsUsers,
            res.muteReviewCommentsUsers,
            res.muteActionDetailsUsers,
            res.muteActionClosureUsers,
            res.summaryDetailsId,
            res.rulebookRuleID,
            res.reviewDate,
            res.reviewerName,
            res.reviewStatus,
            res.actionType,
            res.actionOwner,
            res.actionDueDate,
            res.actionClosureSupportingRationale,
            res.isActionRequired
          );
          this.assessorNameFilterList = this.overallAssessmentData.assessorName?.split(',')?.map((x: string) => {
            return {
              name: x,
              value: x,
              geography: ''
            }
          });
          this.reviewerFilterList = this.overallAssessmentData.reviewerName?.split(',')?.map((x: string) => {
            return {
              name: x,
              value: x,
              geography: ''
            }
          });
          this.actionOwnerFilterList = this.overallAssessmentData.actionOwner?.split(',')?.map((x: string) => {
            return {
              name: x,
              value: x,
              geography: ''
            }
          });
          this.previousOverallAssessmentData = new overallAssessmentDto(
            res.id,
            res.assessorName,
            res.assessmentCategory,
            res.assessmentStatus,
            res.assessmentDate,
            res.nextAssessmentDueDate,
            res.assessorTeam,
            res.impactBusinessArea,
            res.lbgImpact,
            res.rfbImpact,
            res.lbcmImpact,
            res.assessmentFindings,
            res.reviewerComments,
            res.actionDetails,
            res.actionClosed,
            res.assessmentUploadEvidance,
            res.complianceStatus,
            res.muteAssessmentFindingsUsers,
            res.muteReviewCommentsUsers,
            res.muteActionDetailsUsers,
            res.muteActionClosureUsers,
            res.summaryDetailsId,
            res.rulebookRuleID,
            res.reviewDate,
            res.reviewerName,
            res.reviewStatus,
            res.actionType,
            res.actionOwner,
            res.actionDueDate,
            res.actionClosureSupportingRationale,
            res.isActionRequired
          );


        }
      });

  }
  selectedTopicEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.assessorTeam) {
      let sameValueRow = this.assessorTeam.filter(
        obj => obj === event.option.viewValue);
      if (sameValueRow.length == 0) {
        this.assessorTeam.push(event.option.viewValue);
      }
    } else {
      this.assessorTeam = [];
      this.assessorTeam.push(event.option.viewValue);
    }
    if (this.topicInput) {
      this.topicInput.nativeElement.value = '';
    }
    this.searchTopicCntrl.setValue(null);
    this.searchTopicCntrl.disable();
    this.searchTopicCntrl.enable();
  }
  selectedTopicEvent2(event: MatAutocompleteSelectedEvent): void {
    if (this.impactBussinessArea) {
      let sameValueRow = this.impactBussinessArea.filter(
        obj => obj === event.option.viewValue);
      if (sameValueRow.length == 0) {
        this.impactBussinessArea.push(event.option.viewValue);
      }
    } else {
      this.impactBussinessArea = [];
      this.impactBussinessArea.push(event.option.viewValue);
    }
    if (this.topicInput2) {
      this.topicInput2.nativeElement.value = '';
    }
    this.searchTopicCntrl2.setValue(null);
    this.searchTopicCntrl2.disable();
    this.searchTopicCntrl2.enable();
  }
  removeTopic(status: string): void {
    const index = (this.assessorTeam as string[]).indexOf(status);

    if (index >= 0) {
      (this.assessorTeam as string[]).splice(index, 1);
    }
  }
  removeTopic2(status: string): void {
    const index = (this.impactBussinessArea as string[]).indexOf(status);

    if (index >= 0) {
      (this.impactBussinessArea as string[]).splice(index, 1);
    }
  }
  addTopic2(event: MatChipInputEvent): void {
    const value = event.value;
    if (!this.topicAutocomplete2.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.impactBussinessArea.filter(
          obj => obj === value);

        if (sameValueRow.length == 0) {
          (this.impactBussinessArea as string[]).push(value);
        }
      }
      event.chipInput!.clear();
      this.searchTopicCntrl2.setValue(null);
    }
  }
  addTopic(event: MatChipInputEvent): void {
    const value = event.value;
    if (!this.topicAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.assessorTeam.filter(
          obj => obj === value);

        if (sameValueRow.length == 0) {
          (this.assessorTeam as string[]).push(value);
        }
      }
      event.chipInput!.clear();
      this.searchTopicCntrl.setValue(null);
    }
  }
  getOverallAssessmentAllDropDowns() {
    this._selfAssessmentT3Service
      .getT3OverAllAssessmentDropdowns()
      .subscribe((res: overallAssessmentDropdownList) => {

        this.searchedTopic = res.impactedBuisnessAreaList;
        this.overallAssessmentDropdownList = res;
        this.allReviewerList = this.overallAssessmentDropdownList.reviewerName;
        this.allAssessorList = this.overallAssessmentDropdownList.assessorName;
        this.allActionOwnerList = this.overallAssessmentDropdownList.actionOwner;
        this.filterAssessorNameWithoutSelectedItem();
        this.filterReviewerWithoutSelectedItem();
        this.filterActionOwnerWithoutSelectedItem();
        this.searchAssessorCntrl.valueChanges.subscribe((term: any) => {
          this.searchedAssessors = this.filterAssessorName(term);
        });
        this.searchReviewerCntrl.valueChanges.subscribe((term: any) => {
          this.searchedReviewers = this.filterReviewerName(term);
        });
        this.searchActionOwnerCntrl.valueChanges.subscribe((term: any) => {
          this.searchedActionOwner = this.filterActionOwnerName(term);
        });
        // this.filterReviewListBasedOnAssessorAndAction();
        // this.filterAssessorListBasedOnReviewerAndAction();
        // this.filterActionOwnerListBasedOnReviewerAndAssessor();
      });
  }
  filterReviewerName(search: string) {
    const normalizedExcludedOptions = (this.reviewerFilterList ?? []).map(option => option.value.toLowerCase());
    if (search) {
      return this.allReviewerList.filter((option) =>
        option.value.toLowerCase().includes(search.toLowerCase())
        &&
        !normalizedExcludedOptions.includes(option.value.toLowerCase())
      );
    }
    else{
      return this.allReviewerList.filter((option) =>
      !normalizedExcludedOptions.includes(option.value.toLowerCase())
    );
    }
  }

  filterAssessorName(search: string) {
    const normalizedExcludedOptions = (this.assessorNameFilterList ?? []).map(option => option.value.toLowerCase());
    if (search) {
      return this.allAssessorList.filter((option) =>
      option.value.toLowerCase().includes(search.toLowerCase())
      &&
      !normalizedExcludedOptions.includes(option.value.toLowerCase())
    );
    }
    else{
      return this.allAssessorList.filter((option) =>
      !normalizedExcludedOptions.includes(option.value.toLowerCase())
    );
    }
  }

  filterActionOwnerName(search: string) {
    const normalizedExcludedOptions = (this.actionOwnerFilterList ?? []).map(option => option.value.toLowerCase());
    if (search) {
      return this.allActionOwnerList.filter((option) =>
      option.value.toLowerCase().includes(search.toLowerCase())
      &&
      !normalizedExcludedOptions.includes(option.value.toLowerCase())
    );
    }
    else{
      return this.allActionOwnerList.filter((option) =>
      !normalizedExcludedOptions.includes(option.value.toLowerCase())
    );
    }
  }

  isRnArRestricted: boolean = true;
  isAoRestricted: boolean = true;
  isActnDtlsUserRestricted: boolean = true;
  getUserDetails() {
    this.isLoader = true;
    this._sessionService.getLoginUserInfo().subscribe((user: UserProfile) => {
      this.user = user;
      if (this.user.fullName != '') {
        this.getUserRestrictionData();
        this.isLoader = false;
      }
    });
  }
  userPermissionList!: rightsManagementSAT3Dto | undefined;
  async getUserRestrictionData() {
    this.userPermissionList = await this._globalService.getUserPermissionList(
      0,
      this.versionHistoryData.isVersonHistory,
      this.user,
      +this.summaryDetailsId,
      'OverallAssessment'
    );
  }
  getAssessmentDocuments() {
    this.isAssessmentLoader = true;
    this.isReviewLoader = true;
    this._selfAssessmentT3Service
      .getSelfAssessmentT3OverallDocuments(parseInt(this.summaryDetailsId))
      .subscribe((result: SelfAssessmentDocumentModel[]) => {
        this.selfAssessmentDocument = result;
        this.isAssessmentLoader = false;
        this.isReviewLoader = false;
      });
  }
  openDeleteModel(id: number, fileType: string, isPermitted: boolean): void {
    if (isPermitted) {
      const dialogRef = this.dialog.open(ModalDialogComponent, {
        data: {
          message: 'Are you sure want to delete?',
          title: 'Delete Document',
          btnText: 'Delete',
        },
      });
      dialogRef.afterClosed().subscribe((data: any) => {
        if (data) {
          this.removeSelfAssessmentDocumentsT3(id, fileType);
        }
      });
    }
  }
  removeSelfAssessmentDocumentsT3(id: number, fileType: string): void {
    if (fileType === 'overall') {
      this.isAssessmentLoader = true;
    } else if (fileType === 'review') {
      this.isReviewLoader = true;
    } else if (fileType === 'action') {
      this.isActionLoader = true;
    }
    this._selfAssessmentT3Service
      .deleteSelfAssessmentT3Document(id)
      .subscribe((data: any) => {
        if (data.result) {
          if (fileType === 'overall') {
            this.isAssessmentLoader = false;
            this.fetchSelfAssessmentDocuments(FileTypeT3.OverAll);
          } else if (fileType === 'review') {
            this.isReviewLoader = false;
            this.fetchSelfAssessmentDocuments(FileTypeT3.Review);
          } else if (fileType === 'action') {
            this.isActionLoader = false;
            this.fetchSelfAssessmentDocuments(FileTypeT3.Action);
          }
          this.alertMessage('success', data.result);
        }
      });
  }
  downloadDocument(
    id: number,
    fileName: string,
    extension: string,
    fileType: string
  ): void {
    if (fileType === 'overall') {
      this.isAssessmentLoader = true;
    } else if (fileType === 'review') {
      this.isReviewLoader = true;
    } else if (fileType === 'action') {
      this.isActionLoader = true;
    }
    this._selfAssessmentT3Service.downloadEvidenceT3(id).subscribe(
      (data: any) => {
        if (fileType === 'overall') {
          this.isAssessmentLoader = false;
        } else if (fileType === 'review') {
          this.isReviewLoader = false;
        } else if (fileType === 'action') {
          this.isActionLoader = false;
        }
        this._globalService.downloadDocument(data, fileName, extension);
      },
      (err: HttpErrorResponse) => {
        console.error(JSON.stringify(err.message));
      }
    );
  }
  onChildVariableChangeT3(data: any, type: string) {
    if (type.toLowerCase() === 'AssessmentFindings'.toLocaleLowerCase()) {
      this.overallAssessmentData.assessmentFindings = data;
      this.overallAssessmentData.muteAssessmentFindingsUsers =
        this.updateUserList(
          this.overallAssessmentData.muteAssessmentFindingsUsers,
          this.user.fullName
        );
      this.ref.detectChanges();
    } else if (type.toLowerCase() === 'ReviewComments'.toLocaleLowerCase()) {
      this.overallAssessmentData.reviewerComments = data;
      this.overallAssessmentData.muteReviewCommentsUsers = this.updateUserList(
        this.overallAssessmentData.muteReviewCommentsUsers,
        this.user.fullName
      );
      this.ref.detectChanges();
    } else if (type.toLowerCase() === 'ActionDetails'.toLocaleLowerCase()) {
      this.overallAssessmentData.actionDetails = data;
      this.overallAssessmentData.muteActionDetailsUsers = this.updateUserList(
        this.overallAssessmentData.muteActionDetailsUsers,
        this.user.fullName
      );
      this.ref.detectChanges();
    } else if (type.toLowerCase() === 'ActionClosure'.toLocaleLowerCase()) {
      this.overallAssessmentData.actionClosureSupportingRationale = data;
      this.overallAssessmentData.muteActionClosureUsers = this.updateUserList(
        this.overallAssessmentData.muteActionClosureUsers,
        this.user.fullName
      );
      this.ref.detectChanges();
    }
  }
  updateUserList(userlist: string, newUser: string): string {
    if (userlist) {
      const userList: string[] = userlist.split(',');
      const isPresent: boolean = userList.includes(newUser);
      if (!isPresent) {
        userList.push(newUser);
      }
      userlist = userList.join(',');
    } else {
      userlist = newUser;
    }
    return userlist;
  }
  async onEditorSave(data: SelfAssessmentCkDataSaveModel) {
    let payloadData: SelfAssessmentCkDataSaveT3Dto =
      new SelfAssessmentCkDataSaveT3Dto(
        data.ckData,
        data.ckName,
        data.selfAssessmentT2Id,
        this.overallAssessmentData.id,
        data.userName
      );
    this._selfAssessmentT3Service
      .updateSelfAssessmentCKT3(payloadData)
      .subscribe((res: any) => {
        this.alertMessage('success', ' Saved successfully');
        setTimeout(() => { }, 3500);
        this.notifyDetailsComponentCkEditorChange();
      });
  }

  uploadEvidenceAssessment() {
    if (this.userPermissionList?.UplEvdOvrAllAsmnt) {
      const fileInput = document.getElementById(
        'uploadEviAssessmentT3'
      ) as HTMLElement;
      fileInput.click();
    }
  }
  handleFileInput(files: FileList) {
    for (let i = 0; i < files.length; i++) {
      this.uploadFileToActivity(files[i], FileTypeT3.OverAll);
    }
    this.uploadEviAssessmentT3.nativeElement.value = '';
  }
  uploadReviewEvidenceAssessment() {
    if (this.userPermissionList?.UplEvdOvrAllReview) {
      const fileInput = document.getElementById(
        'reviewEvidanceT3'
      ) as HTMLElement;
      fileInput.click();
    }
  }
  handleFileInputReview(files: FileList) {
    for (let i = 0; i < files.length; i++) {
      this.uploadFileToActivity(files[i], FileTypeT3.Review);
    }
    this.reviewEvidanceT3.nativeElement.value = '';
  }
  uploadActionEvidenceAssessment() {
    if (this.userPermissionList?.UplEvdAction) {
      const fileInput = document.getElementById(
        'ActionEvidanceT3'
      ) as HTMLElement;
      fileInput.click();
    }
  }
  handleFileInputAction(files: FileList) {
    for (let i = 0; i < files.length; i++) {
      this.uploadFileToActivity(files[i], FileTypeT3.Action);
    }
    this.ActionEvidanceT3.nativeElement.value = '';
  }
  uploadFileToActivity(fileToUpload: any, fileType: FileTypeT3) {
    if (fileType === FileTypeT3.OverAll) {
      this.isAssessmentLoader = true;
    } else if (fileType === FileTypeT3.Review) {
      this.isReviewLoader = true;
    } else if (fileType === FileTypeT3.Action) {
      this.isActionLoader = true;
    }
    this._selfAssessmentT3Service
      .UploadEvidenceT3(fileToUpload, fileType, this.summaryDetailsId)
      .subscribe(
        (data: any) => {
          this.fetchSelfAssessmentDocuments(fileType);
          this.updateSectionLastEdited(fileType);
          if (fileType === FileTypeT3.OverAll) {
            this.isAssessmentLoader = false;
          } else if (fileType === FileTypeT3.Review) {
            this.isReviewLoader = false;
          } else if (fileType === FileTypeT3.Action) {
            this.isActionLoader = false;
          }
        },
        (err: HttpErrorResponse) => {
          this.isAssessmentLoader = false;
          this.isReviewLoader = false;
          this.isActionLoader = false;
          this.alertMessage(
            'warning',
            'File not uploaded, please check your file'
          );
          setTimeout(() => { }, 3500);
        }
      );
  }
  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3500);
  }
  updateSectionLastEdited(filter: FileTypeT3): void {
    switch (filter) {
      case 1:
        this.isAssessmentLastEdited = true;
        break;
      case 2:
        this.isReviewLastEdited = true;
        break;
      case 3:
        this.isActionLastEdited = true;
        break;
    }
  }
  fetchSelfAssessmentDocuments(fileType: FileTypeT3): void {
    if (fileType === FileTypeT3.OverAll) {
      this.isAssessmentLoader = true;
    } else if (fileType === FileTypeT3.Review) {
      this.isReviewLoader = true;
    } else if (fileType === FileTypeT3.Action) {
      this.isActionLoader = true;
    }
    this._selfAssessmentT3Service
      .getSelfAssessmentT3OverallDocuments(parseInt(this.summaryDetailsId))
      .subscribe((result: SelfAssessmentDocumentModel[]) => {
        this.selfAssessmentDocument = result;
        if (fileType === FileTypeT3.OverAll) {
          this.isAssessmentLoader = false;
        } else if (fileType === FileTypeT3.Review) {
          this.isReviewLoader = false;
        } else if (fileType === FileTypeT3.Action) {
          this.isActionLoader = false;
        }
      });
  }
  async saveOverAllAssessment() {
    if (this.ckEditorComponent) {
      this.ckEditorComponent.forEach(async (editor) => {
        if (editor?.buttonActive) {
          await editor?.CalledUpdatedSelfAssessmentData();
        }
      });
    }
  }
  async editorSave() {
    if (this.ckEditorComponent) {
      for (const editor of this.ckEditorComponent) {
        if (editor?.buttonActive) {
          await editor?.CalledUpdatedSelfAssessmentData();
        }
      }
    }
  }
  async saveAssessmentData() {
    this.isButtonDisabled = true;
    const currentUrl = window.location.href;
    this.overallAssessmentData.assessmentDate = this.overallAssessmentData
      .assessmentDate
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.overallAssessmentData.assessmentDate.toString()
      )
      : null;
    this.overallAssessmentData.nextAssessmentDueDate = this
      .overallAssessmentData.nextAssessmentDueDate
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.overallAssessmentData.nextAssessmentDueDate.toString()
      )
      : null;

    if (this.isBulkUpdate) {
      const data: overAllAssessmentSaveData = new overAllAssessmentSaveData(
        this.overallAssessmentData
      );
      data.impactBusinessArea = this.impactBussinessArea.toString();
      data.assessorTeam = this.assessorTeam.toString();
      this._selfAssessmentT3Service
        .bulkUpdatepdateSelfAssessmentT3(data, this.selectedItems)
        .subscribe((res) => {
          this.alertMessage('success', 'Overall assessment saved successfully');
          setTimeout(() => { }, 3500);
          this.isButtonDisabled = false;
        });
    } else {
      await this.editorSave();
      const data: overAllAssessmentSaveData = new overAllAssessmentSaveData(
        this.overallAssessmentData
      );
      data.impactBusinessArea = this.impactBussinessArea.toString();
      data.assessorTeam = this.assessorTeam.toString();
      this._selfAssessmentT3Service
        .updateSelfAssessmentOverallAssesssmentT3(data, currentUrl)
        .subscribe((res) => {
          this.alertMessage('success', 'Overall assessment saved successfully');
          setTimeout(() => { }, 3500);
          this.isButtonDisabled = false;
          this.previousOverallAssessmentData = cloneDeep(this.overallAssessmentData);
        });
    }
    this.isUserRestricted = true;
    this.isReviewUserRestricted = true;
    this.isRnArRestricted = true;
    this.isAoRestricted = true;
    this.isActnDtlsUserRestricted = true;
    this.getUserRestrictionData();
  }
  async saveReviewData() {
    this.isButtonDisabledReview = true;
    const currentUrl = window.location.href;
    this.overallAssessmentData.reviewDate = this.overallAssessmentData
      .reviewDate
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.overallAssessmentData.reviewDate.toString()
      )
      : null;
    if (this.isBulkUpdate) {
      const data: overAllReviewSaveData = new overAllReviewSaveData(
        this.overallAssessmentData
      );
      this._selfAssessmentT3Service
        .bulkUpdatepdateSelfAssessmentT3Review(data, this.selectedItems)
        .subscribe((res) => {
          this.alertMessage('success', 'Overall assessment saved successfully');
          setTimeout(() => { }, 3500);
          this.isButtonDisabled = false;
        });
    } else {
      await this.editorSave();
      const data: overAllReviewSaveData = new overAllReviewSaveData(
        this.overallAssessmentData
      );
      this._selfAssessmentT3Service
        .updateSelfAssessmentOverallReviewT3(data, currentUrl)
        .subscribe((res) => {
          this.alertMessage('success', 'Overall assessment saved successfully');
          setTimeout(() => { }, 3500);
          this.isButtonDisabledReview = false;
        });
    }
    this.isUserRestricted = true;
    this.isReviewUserRestricted = true;
    this.isRnArRestricted = true;
    this.isAoRestricted = true;
    this.isActnDtlsUserRestricted = true;
    this.getUserRestrictionData();
  }
  async saveAssessmentActionData() {
    this.isButtonDisabledAction = true;
    const currentUrl = window.location.href;
    this.overallAssessmentData.actionDueDate = this.overallAssessmentData
      .actionDueDate
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.overallAssessmentData.actionDueDate.toString()
      )
      : null;
    this.overallAssessmentData.actionClosed = this.overallAssessmentData
      .actionClosed
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.overallAssessmentData.actionClosed.toString()
      )
      : null;
    if (this.isBulkUpdate) {
      const data: overAllApprovalSaveData = new overAllApprovalSaveData(
        this.overallAssessmentData
      );
      this.isButtonDisabled = false;
      this._selfAssessmentT3Service
        .bulkUpdatepdateSelfAssessmentT3Action(data, this.selectedItems)
        .subscribe((res) => {
          this.alertMessage('success', 'Overall assessment saved successfully');
          setTimeout(() => { }, 3500);
          this.isButtonDisabled = false;
        });
    } else {
      await this.editorSave();
      const data: overAllApprovalSaveData = new overAllApprovalSaveData(
        this.overallAssessmentData
      );
      this._selfAssessmentT3Service
        .updateSelfAssessmentOverallApprovalsT3(data, currentUrl)
        .subscribe((res) => {
          this.alertMessage('success', 'Overall assessment saved successfully');
          setTimeout(() => { }, 3500);
          this.isButtonDisabledAction = false;
        });
    }
    this.isUserRestricted = true;
    this.isReviewUserRestricted = true;
    this.isRnArRestricted = true;
    this.isAoRestricted = true;
    this.isActnDtlsUserRestricted = true;
    this.getUserRestrictionData();
  }
  openDialog(): void {
    const filterDataModel = new VersionFilterViewT3Model();
    filterDataModel.overallAssessmentId = this.overallAssessmentData.id;
    filterDataModel.filterType = 'version';
    filterDataModel.templateId = 3;
    filterDataModel.versionType = 'overall';
    filterDataModel.summuryDetailsId = this.summaryDetailsId;
    const dialogRef = this.dialog.open(SelfAssessmentDialogComponent, {
      data: filterDataModel,
      width: '750px',
    });
    dialogRef.afterClosed().subscribe(() => { });
  }
  fetchSelfAssessmentVersionHistoryDetails() {
    this._selfAssessmentT3Service
      .getOverallAssessmentVersionHistoryDetails(
        this.versionHistoryData.overAssessmentId
      )
      .subscribe((res: overallAssessmentDto) => {
        if (res) {
          this.overallAssessmentData = new overallAssessmentDto(
            res.id,
            res.assessorName,
            res.assessmentCategory,
            res.assessmentStatus,
            res.assessmentDate,
            res.nextAssessmentDueDate,
            res.assessorTeam,
            res.impactBusinessArea,
            res.lbgImpact,
            res.rfbImpact,
            res.lbcmImpact,
            res.assessmentFindings,
            res.reviewerComments,
            res.actionDetails,
            res.actionClosed,
            res.assessmentUploadEvidance,
            res.complianceStatus,
            res.muteAssessmentFindingsUsers,
            res.muteReviewCommentsUsers,
            res.muteActionDetailsUsers,
            res.muteActionClosureUsers,
            res.summaryDetailsId,
            res.rulebookRuleID,
            res.reviewDate,
            res.reviewerName,
            res.reviewStatus,
            res.actionType,
            res.actionOwner,
            res.actionDueDate,
            res.actionClosureSupportingRationale,
            res.isActionRequired
          );
          this.assessorNameFilterList = this.overallAssessmentData.assessorName?.split(',')?.map((x: string) => {
            return {
              name: x,
              value: x,
              geography: ''
            }
          });
          this.reviewerFilterList = this.overallAssessmentData.reviewerName?.split(',')?.map((x: string) => {
            return {
              name: x,
              value: x,
              geography: ''
            }
          });
          this.actionOwnerFilterList = this.overallAssessmentData.actionOwner?.split(',')?.map((x: string) => {
            return {
              name: x,
              value: x,
              geography: ''
            }
          });
        }
        this.previousOverallAssessmentData = { ...this.overallAssessmentData };
        // this.previousOverallAssessmentData=this.overallAssessmentData;
      });
  }
  @Output() notifyCkEditorChange: EventEmitter<any> = new EventEmitter<any>();
  notifyDetailsComponentCkEditorChange() {
    this.notifyCkEditorChange.emit();
  }

  isDataChange: boolean = false;
  performLeaveCheck(): boolean {
    const currentDataStr = JSON.stringify(this.overallAssessmentData);
    const previousDataStr = JSON.stringify(this.previousOverallAssessmentData);
    if (currentDataStr !== previousDataStr) {
      this.isDataChange = true;
      // Perform actions based on changes
    } else {
      this.isDataChange = false;
    }
    return this.isDataChange;
  }

  filterReviewerWithoutSelectedItem() {
    if (this.reviewerFilterList && this.reviewerFilterList.length > 0) {
      this.searchedReviewers =
        this.overallAssessmentDropdownList.reviewerName.filter(
          (obj: userDropdownDto) =>
            !this.reviewerFilterList.some(
              (filterObj) => filterObj.value === obj.value
            )
        );
    } else {
      this.searchedReviewers = this.overallAssessmentDropdownList.reviewerName;
    }
    this.filterReviewListBasedOnAssessorAndAction();
  }
  addReview(event: MatChipInputEvent) {
    const value = event.value;
    if (!this.reviewerAutoComplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.reviewerFilterList?.find(
          (option: userDropdownDto) => option.value == value
        );
      }
      this.filterReviewerWithoutSelectedItem();
      event.chipInput!.clear();
      this.searchReviewerCntrl.setValue(null);
    }
  }
  selectedReviewerEvent(event: MatAutocompleteSelectedEvent) {
    if (this.reviewerFilterList) {
      let sameValueRow = this.reviewerFilterList.filter(
        (option: userDropdownDto) => option.name == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addReviewerFilterListFn(event.option.viewValue);
      }
    } else {
      this.reviewerFilterList = [];
      this.addReviewerFilterListFn(event.option.viewValue);
    }
    if (this.reviewerInput) {
      this.reviewerInput.nativeElement.value = '';
    }
    this.searchReviewerCntrl.setValue(null);
    this.searchReviewerCntrl.disable();
    this.searchReviewerCntrl.enable();
    this.filterReviewerWithoutSelectedItem();
  }
  addReviewerFilterListFn(matchString: string) {
    let selectedValue: userDropdownDto | undefined =
      this.overallAssessmentDropdownList.reviewerName.find(
        (option) => option.name == matchString
      );
    if (selectedValue) {
      this.reviewerFilterList.push(selectedValue);
      this.overallAssessmentData.reviewerName = this.reviewerFilterList?.map(x => x.name).join(',');
      this.searchedAssessors = this.searchedAssessors.filter(ob => ob.name != matchString);
      this.allAssessorList = this.allAssessorList.filter(ob => ob.name != matchString);
      // this.searchedActionOwner = this.searchedActionOwner.filter(ob => ob.name != matchString);
    }
  }
  removeReview(value: string) {
    if (this.reviewerFilterList && this.reviewerFilterList.length > 0) {
      const index = this.reviewerFilterList.findIndex(
        (obj: userDropdownDto) => obj.value == value
      );
      if (index >= 0) {
        this.reviewerFilterList.splice(index, 1);
        this.overallAssessmentData.reviewerName = this.reviewerFilterList?.map(x => x.name).join(',');
      }
      this.filterReviewerWithoutSelectedItem();

      // let actionFilterRow = this.overallAssessmentDropdownList.actionOwner.filter(ob => ob.name == value);
      // let actionSearchedFilterRow = this.searchedActionOwner.filter(ob => ob.name == value);
      // if (actionFilterRow.length > 0 && actionSearchedFilterRow.length == 0) {
      //   this.searchedActionOwner.push(actionFilterRow[0]);
      //   this.searchedActionOwner = this.searchedActionOwner.sort((a, b) => a.name.localeCompare(b.name));
      // }

      let assessorFilterRow = this.overallAssessmentDropdownList.assessorName.filter(ob => ob.name == value);
      let assessorSearchedFilterRow = this.searchedAssessors.filter(ob => ob.name == value);
      if (assessorFilterRow.length > 0 && assessorSearchedFilterRow.length == 0) {
        this.searchedAssessors.push(assessorFilterRow[0]);
        this.searchedAssessors = this.searchedAssessors.sort((a, b) => a.name.localeCompare(b.name));
      }
    }
  }
  //assessor name multi select
  assessorNameFilterList: userDropdownDto[] = [];
  searchedAssessors: userDropdownDto[] = [];
  @ViewChild('assessorAutoComplete')
  assessorAutoComplete!: MatAutocomplete;
  searchAssessorCntrl: FormControl = new FormControl();
  @ViewChild('assessorInput')
  assessorInput!: ElementRef<HTMLInputElement>;
  filterAssessorNameWithoutSelectedItem() {
    if (this.assessorNameFilterList && this.assessorNameFilterList.length > 0) {
      this.searchedAssessors =
        this.overallAssessmentDropdownList.assessorName.filter(
          (obj: userDropdownDto) =>
            !this.assessorNameFilterList.some(
              (filterObj) => filterObj.value === obj.value
            )
        );
    } else {
      this.searchedAssessors = this.overallAssessmentDropdownList.assessorName;
    }
    this.filterAssessorListBasedOnReviewerAndAction();
  }
  addAssessor(event: MatChipInputEvent) {
    const value = event.value;
    if (!this.assessorAutoComplete.isOpen) {
      this.filterAssessorNameWithoutSelectedItem();
      event.chipInput!.clear();
      this.searchAssessorCntrl.setValue(null);
    }
  }
  selectedAssessorEvent(event: MatAutocompleteSelectedEvent) {
    if (this.assessorNameFilterList) {
      let sameValueRow = this.assessorNameFilterList.filter(
        (option: userDropdownDto) => option.name == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addAssessorFilterListFn(event.option.viewValue);
      }
    } else {
      this.assessorNameFilterList = [];
      this.addAssessorFilterListFn(event.option.viewValue);
    }
    if (this.assessorInput) {
      this.assessorInput.nativeElement.value = '';
    }
    this.searchAssessorCntrl.setValue(null);
    this.searchAssessorCntrl.disable();
    this.searchAssessorCntrl.enable();
    this.filterAssessorNameWithoutSelectedItem();
  }
  addAssessorFilterListFn(matchString: string) {
    let selectedValue: userDropdownDto | undefined =
      this.overallAssessmentDropdownList.assessorName.find(
        (option) => option.name == matchString
      );
    if (selectedValue) {
      this.assessorNameFilterList.push(selectedValue);
      this.overallAssessmentData.assessorName = this.assessorNameFilterList?.map(x => x.name).join(',');
      this.searchedReviewers = this.searchedReviewers.filter(ob => ob.name != matchString);
      this.allReviewerList = this.allReviewerList.filter(ob => ob.name != matchString)
      // this.searchedActionOwner = this.searchedActionOwner.filter(ob => ob.name != matchString);
    }
  }
  removeAssessor(value: string) {
    if (this.assessorNameFilterList && this.assessorNameFilterList.length > 0) {
      const index = this.assessorNameFilterList.findIndex(
        (obj: userDropdownDto) => obj.value == value
      );
      if (index >= 0) {
        this.assessorNameFilterList.splice(index, 1);
        this.overallAssessmentData.assessorName = this.assessorNameFilterList?.map(x => x.name).join(',');
      }
      this.filterAssessorNameWithoutSelectedItem();

      let reviewFilterRow = this.overallAssessmentDropdownList.reviewerName.filter(ob => ob.name == value);
      let reviewSearchedFilterRow = this.searchedReviewers.filter(ob => ob.name == value);
      if (reviewFilterRow.length > 0 && reviewSearchedFilterRow.length == 0) {
        this.searchedReviewers.push(reviewFilterRow[0]);
        this.searchedReviewers = this.searchedReviewers.sort((a, b) => a.name.localeCompare(b.name));
      }

      // let actionFilterRow = this.overallAssessmentDropdownList.actionOwner.filter(ob => ob.name == value);
      // let actionSearchedFilterRow = this.searchedActionOwner.filter(ob => ob.name == value);
      // if (actionFilterRow.length > 0 && actionSearchedFilterRow.length == 0) {
      //   this.searchedActionOwner.push(actionFilterRow[0]);
      //   this.searchedActionOwner = this.searchedActionOwner.sort((a, b) => a.name.localeCompare(b.name));
      // }
    }
  }
  //action owner name multi select
  actionOwnerFilterList: userDropdownDto[] = [];
  searchedActionOwner: userDropdownDto[] = [];
  @ViewChild('actionOwnerAutoComplete')
  actionOwnerAutoComplete!: MatAutocomplete;
  searchActionOwnerCntrl: FormControl = new FormControl();
  @ViewChild('actionOwnerInput')
  actionOwnerInput!: ElementRef<HTMLInputElement>;
  filterActionOwnerWithoutSelectedItem() {
    if (this.actionOwnerFilterList && this.actionOwnerFilterList.length > 0) {
      this.searchedActionOwner =
        this.overallAssessmentDropdownList.actionOwner.filter(
          (obj: userDropdownDto) =>
            !this.actionOwnerFilterList.some(
              (filterObj) => filterObj.value === obj.value
            )
        );
    } else {
      this.searchedActionOwner = this.overallAssessmentDropdownList.actionOwner;
    }
    // this.filterActionOwnerListBasedOnReviewerAndAssessor();
  }
  addActionOwner(event: MatChipInputEvent) {
    const value = event.value;
    if (!this.actionOwnerAutoComplete.isOpen) {
      this.filterActionOwnerWithoutSelectedItem();
      event.chipInput!.clear();
      this.searchActionOwnerCntrl.setValue(null);
    }
  }
  selectedActionOwnerEvent(event: MatAutocompleteSelectedEvent) {
    if (this.actionOwnerFilterList) {
      let sameValueRow = this.actionOwnerFilterList.filter(
        (option: userDropdownDto) => option.name == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addActionOwnerFilterListFn(event.option.viewValue);
      }
    } else {
      this.actionOwnerFilterList = [];
      this.addActionOwnerFilterListFn(event.option.viewValue);
    }
    if (this.actionOwnerInput) {
      this.actionOwnerInput.nativeElement.value = '';
    }
    this.searchActionOwnerCntrl.setValue(null);
    this.searchActionOwnerCntrl.disable();
    this.searchActionOwnerCntrl.enable();
    this.filterActionOwnerWithoutSelectedItem();
  }
  addActionOwnerFilterListFn(matchString: string) {
    let selectedValue: userDropdownDto | undefined =
      this.overallAssessmentDropdownList.actionOwner.find(
        (option) => option.name == matchString
      );
    if (selectedValue) {
      this.actionOwnerFilterList.push(selectedValue);
      this.overallAssessmentData.actionOwner = this.actionOwnerFilterList?.map(x => x.name).join(',');
      // this.searchedReviewers = this.searchedReviewers.filter(ob => ob.name != matchString);
      // this.searchedAssessors = this.searchedAssessors.filter(ob => ob.name != matchString);
    }
  }
  removeActionOwner(value: string) {
    if (this.actionOwnerFilterList && this.actionOwnerFilterList.length > 0) {
      const index = this.actionOwnerFilterList.findIndex(
        (obj: userDropdownDto) => obj.value == value
      );
      if (index >= 0) {
        this.actionOwnerFilterList.splice(index, 1);
        this.overallAssessmentData.actionOwner = this.actionOwnerFilterList?.map(x => x.name).join(',');
      }
      this.filterActionOwnerWithoutSelectedItem();

      // let reviewFilterRow = this.overallAssessmentDropdownList.reviewerName.filter(ob => ob.name == value);
      // let reviewSearchedFilterRow = this.searchedReviewers.filter(ob => ob.name == value);
      // if (reviewFilterRow.length > 0 && reviewSearchedFilterRow.length == 0) {
      //   this.searchedReviewers.push(reviewFilterRow[0]);
      //   this.searchedReviewers = this.searchedReviewers.sort((a, b) => a.name.localeCompare(b.name));
      // }

      // let assessorFilterRow = this.overallAssessmentDropdownList.assessorName.filter(ob => ob.name == value);
      // let assessorSearchedFilterRow = this.searchedAssessors.filter(ob => ob.name == value);
      // if (assessorFilterRow.length > 0 && assessorSearchedFilterRow.length == 0) {
      //   this.searchedAssessors.push(reviewFilterRow[0]);
      //   this.searchedAssessors = this.searchedAssessors.sort((a, b) => a.name.localeCompare(b.name));
      // }
    }
  }

  filterAssessorListBasedOnReviewerAndAction() {
    const reviewerNames = this.reviewerFilterList?.map(item => item.value);
    // this.searchedAssessors = this.searchedAssessors?.filter(assessor => 
    //   Array.isArray(reviewerNames) && !reviewerNames.includes(assessor.value)
    // );
    if (reviewerNames) {
      this.searchedAssessors = this.searchedAssessors?.filter(assessor => !reviewerNames.includes(assessor.value));
      this.allAssessorList = this.allAssessorList?.filter(reviewer => !reviewerNames.includes(reviewer.value));
    }
    // const actionNames = this.actionOwnerFilterList.map(item => item.value);
    // this.searchedAssessors = this.searchedAssessors.filter(assessor => !actionNames.includes(assessor.value));
  }

  filterReviewListBasedOnAssessorAndAction() {
    const assessorNames = this.assessorNameFilterList?.map(item => item.value);
    if (assessorNames) {
      this.searchedReviewers = this.searchedReviewers?.filter(reviewer => !assessorNames.includes(reviewer.value));
      this.allReviewerList = this.allReviewerList?.filter(reviewer => !assessorNames.includes(reviewer.value));
    }
    // const actionNames = this.actionOwnerFilterList.map(item => item.value);
    // this.searchedReviewers = this.searchedReviewers.filter(reviewer => !actionNames.includes(reviewer.value));
  }

  // filterActionOwnerListBasedOnReviewerAndAssessor() {
  //   const reviewerNames = this.reviewerFilterList.map(item => item.value);
  //   this.searchedActionOwner = this.searchedActionOwner.filter(action => !reviewerNames.includes(action.value));
  //   const assessorNames = this.assessorNameFilterList.map(item => item.value);
  //   this.searchedActionOwner = this.searchedActionOwner.filter(action => !assessorNames.includes(action.value));
  // }
}
